import React from "react";
import BgImage from "./components/BgImage"; 

function App() {
    return (
        <div className="App">
            <BgImage /> 
        </div>
    );
}

export default App;
